export {InputPrimitiveModule} from './input-primitive.module';
export * from './input-primitive.component';
